import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=6a6774fc&scoped=true&"
import script from "./AddressDialog.vue?vue&type=script&lang=js&"
export * from "./AddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddressDialog.vue?vue&type=style&index=0&id=6a6774fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6774fc",
  null
  
)

export default component.exports